<template>
  <div v-if="items.length > 0" class="min-w-0">
    <nav>
      <ul
        ref="categorylist"
        aria-label="Alakategoriat"
        :class="limitResults ? 'flex-row' : 'flex-col'"
        class="flex flex-wrap gap-2 sm:flex-row"
      >
        <li v-for="item in items" :key="item.label" class="flex-none max-w-full">
          <NuxtLink :to="item.path" class="max-w-full transition-colors whitespace-nowrap border border-transparent bg-grey-50 hover:bg-grey-100 text-secondary font-medium inline-flex py-2 px-4 rounded-full items-center hover:no-underline">
            <span class="truncate">{{ item.label }}</span>
          </NuxtLink>
        </li>
        <li v-if="allItems > items">
          <button class="transition-colors whitespace-nowrap border hover:border-grey-700 text-secondary font-medium inline-flex gap-2 py-2 px-4 rounded-full items-center hover:no-underline" @click="limitResults = !limitResults">
            Näytä lisää <span class="opacity-70 font-normal" v-text="allItems.length - items.length" />
          </button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { useAutoAnimate } from '@formkit/auto-animate/vue'
import { useCategoryStore } from '~/stores/category'
import type { CategoryMenuItem } from '~/types/category'

// Define props
const props = defineProps<{
  categoryPath: string
  sortAlphabetically?: boolean
}>()

const [categorylist, enable] = useAutoAnimate()

// Set default values for optional props
const sortAlphabetically = props.sortAlphabetically ?? false

// Access the store
const store = useCategoryStore()

// Computed properties
const subCategories = computed<CategoryMenuItem[]>(() => {
  const subCategories = store.getSubCategoriesByPath(props.categoryPath)
  return sortAlphabetically
    ? subCategories.slice().sort((a, b) => a.name.localeCompare(b.name, 'fi'))
    : subCategories
})

const limitResults = ref(true)

const allItems = computed(() => {
  return subCategories.value.map(cat => ({
    label: cat.name || '',
    image: cat.product,
    path: `/${cat.path}`
  }))
})

const items = computed(() => (limitResults.value && allItems.value.length > 8) ? allItems.value.slice(0, 6) : allItems.value)

onMounted(() => {
  enable(false) // Disable animations
  if (window !== undefined && window.innerWidth >= 1200) {
    limitResults.value = false
  }
  else {
    enable(true) // Enable animations on mobile
  }
})
</script>
